import { withAuthenticator, ThemeProvider, useTheme, View, Image } from '@aws-amplify/ui-react';
import App from './App';
import logo from './img/c2c_technologies_logo.jpg';

// Tema alineado con los design tokens de la app (--c2c-* en index.scss)
const theme = {
  name: 'c2c',
  tokens: {
    colors: {
      brand: {
        primary: {
          10: '#eff6ff',
          80: '#2563eb',  // --c2c-primary
          90: '#1d4ed8',  // --c2c-primary-hover
          100: '#1e40af',
        },
      },
    },
    components: {
      authenticator: {
        router: {
          borderColor: { value: '#e2e8f0' },          // --c2c-border
          backgroundColor: { value: '#ffffff' },        // --c2c-surface
        },
      },
      button: {
        primary: {
          backgroundColor: { value: '#2563eb' },
          _hover: { backgroundColor: { value: '#1d4ed8' } },
          _focus: { backgroundColor: { value: '#1d4ed8' } },
          _active: { backgroundColor: { value: '#1e40af' } },
        },
      },
    },
  },
};

const components = {
  Header() {
    const { tokens } = useTheme();
    return (
      <View textAlign="center" padding={tokens.space.large}>
        <Image
          alt="C2C Technologies"
          src={logo}
          height="64px"
          style={{ mixBlendMode: 'multiply' }}
        />
      </View>
    );
  },
};

const AppWithAuth = withAuthenticator(App, { components, hideSignUp: true });

export default function AuthenticatedApp() {
  return (
    <ThemeProvider theme={theme}>
      <AppWithAuth />
    </ThemeProvider>
  );
}
